import { render } from "./NavComponent.vue?vue&type=template&id=6c74d1fd"
import script from "./NavComponent.vue?vue&type=script&lang=js"
export * from "./NavComponent.vue?vue&type=script&lang=js"

import "./NavComponent.vue?vue&type=style&index=0&id=6c74d1fd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__